// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2GPfj","choiceBoxes":"toolbarselects_choiceBoxes__3beaN","simpleField":"toolbarselects_simpleField__3-FbX"};